<div class="modal-header"><h2 class="modal-title">Inventory Adjustment</h2></div>
<div class="modal-body">
    <div *ngIf="partPurchase && partsDS">
        <dx-form [formData]="partPurchase">
            <dxi-item
                dataField="partId"
                [label]="{ text: 'Part Number' }"
                editorType="dxSelectBox"
                [editorOptions]="{ dataSource: partsDS, valueExpr: 'id', displayExpr: 'displayName', searchEnabled: true, showClearButton: true }"
            ></dxi-item>
            <dxi-item
                dataField="partId"
                [label]="{ text: 'Mfg Part Number' }"
                editorType="dxSelectBox"
                [editorOptions]="{ dataSource: partsDS, valueExpr: 'id', displayExpr: 'mfgDisplayName', searchEnabled: true, showClearButton: true }"
            ></dxi-item>
            <dxi-item [label]="{ text: 'In Stock' }">
                <div *dxTemplate>
                    <dx-text-box [(value)]="selectedPart.inStock" [disabled]="true"> </dx-text-box>
                </div>
            </dxi-item>
            <dxi-item [label]="{ text: 'Allocated' }">
                <div *dxTemplate>
                    <dx-text-box [(value)]="selectedPart.allocated" [disabled]="true"> </dx-text-box>
                </div>
            </dxi-item>
            <dxi-item [label]="{ text: 'Proj. Inv.' }">
                <div *dxTemplate>
                    <dx-text-box [(value)]="selectedPart.projectedInventory" [disabled]="true" > </dx-text-box>
                </div>
            </dxi-item>
            <!-- <dxi-item dataField="quantity" [disabled]="quantityDisabled"></dxi-item> -->
            <dxi-item [label]="{ text: 'Quantity' }">
                <div *dxTemplate>
                    <dx-number-box [(value)]="quantity" [disabled]="quantityDisabled" > </dx-number-box>
                </div>
            </dxi-item>
            <dxi-item dataField="date" editorType="dxDateBox"></dxi-item>
            <dxi-item dataField="price" [label]="{text: 'Cost'}" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00' }"></dxi-item>
            <dxi-item dataField="reason" editorType="dxTextArea" [editorOptions]="{ height: 100 }"></dxi-item>
            <dxi-item [label]="{ text: 'Attachments' }">
                <div *dxTemplate>
                    <dx-file-uploader
                        name="fileUpload"
                        selectButtonText="Select File(s)"
                        accept="*"
                        uploadMode="instantly"
                        [showFileList]="false"
                        [multiple]="true"
                        [uploadUrl]="uploadUrl"
                        [uploadHeaders]="uploadHeader"
                        (onUploadStarted)="uploadStarted($event)"
                        (onUploadError)="uploadError($event)"
                        (onUploaded)="uploaded($event)"
                    >
                    </dx-file-uploader>
                    <ul style="list-style-type: none; padding-inline-start: 15px">
                        @for (attachment of attachments; track attachment) {
                            <li>
                                <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                                <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                            </li>
                        }
                    </ul>
                </div>
            </dxi-item>
        </dx-form>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-success" (click)="save()" [disabled]="processing || uploadsInProgress > 0" >Save</button>
    <button class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
